import { render } from "./signature-pad.vue?vue&type=template&id=6d3ca291"
import script from "./signature-pad.vue?vue&type=script&lang=js"
export * from "./signature-pad.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__